<template>
	
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<el-tabs class="mt-3" v-model="type" @tab-click="handleClick" type="card">
		   <el-tab-pane  :label="$t('record.statusall')" name="1"></el-tab-pane>
		   <el-tab-pane  :label="$t('record.status2')" name="2"></el-tab-pane>
		   
		 </el-tabs>
		<div class="mb-2 mt-2 pt-3">
				<template>
					<el-form inline ref="form" :model="from" label-width="100px">
						<el-form-item :label="$t('record.task_id')" class="mb-0">
							<el-input size="small" v-model="from.name" ></el-input>
						</el-form-item>
						
						<el-form-item :label="$t('record.app')" class="mb-0">
							<el-input size="small" v-model="from.app" ></el-input>
						</el-form-item>
						
						<el-form-item :label="$t('record.stream')" class="mb-0">
							<el-input size="small" v-model="from.username" ></el-input>
						</el-form-item>
						
						
						
						
						
						
                      <!-- <el-form-item :label="$t('status.status')" class="mb-0">
							<el-select v-model="from.status" size="small" :placeholder="$t('system.select')">
								<el-option :label="$t('status.all')" :value="-1"></el-option>
								<el-option :label="$t('record.status')" :value="1"></el-option>
							</el-select>
						</el-form-item> -->
						
						<el-form-item :label="$t('layout.createTime')"  class="mb-0">
							 <el-date-picker
							      size="small"
							      v-model="from.time"
							      type="daterange"
							      align="right"
							      unlink-panels
								  value-format="yyyy-MM-dd"
							      :range-separator="$t('system.to')"
							      :start-placeholder="$t('system.startTime')"
							      :end-placeholder="$t('system.endTime')"
							      >
							    </el-date-picker>
						</el-form-item>
						
						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">{{$t('system.search')}}</el-button>
							<el-button size="small" @click="clearSearch">{{$t('system.reset')}}</el-button>
						</el-form-item>
				
					</el-form>
					<div style="margin-top:10px">
						<el-button size="small" @click="openModel(false)" v-auth="'add'+auth_val" >{{$t('record.add')}}</el-button>
						
						<span class="ml-3" @click="apiModel = true" style="cursor: pointer;color: rgb(64, 158, 255);font-size: 14px;">
													  
							<i class="el-icon-warning-outline mr-1"></i>{{$t('record.apiTis')}}
						</span>
					</div>
			</template>
		</div>

		<!-- 表格 -->
		<div class="mt-3 pt-2" style="padding-bottom:20px">
			<el-table :data="tableData" style="width: 100%" size="mini" @selection-change="handleSelectionChange">
				<el-table-column show-overflow-tooltip="" align="center" fixed prop="task_id" width="180" :label="$t('record.task_id')">
				</el-table-column>
				
				
				
				<el-table-column width="140" show-overflow-tooltip="" align="center"  prop="domain" :label="$t('live.type1')">
				</el-table-column>
				
				<el-table-column align="center" prop="app" :label="$t('record.app')">
				</el-table-column>
				<el-table-column align="center" prop="stream" :label="$t('record.stream')">
				</el-table-column>
				<el-table-column align="center" prop="m_name" :label="$t('record.model')">
				</el-table-column>
				
				<el-table-column align="center" prop="status" width="180" :label="$t('status.status')">
					<template slot-scope="scope">
						<span v-if="scope.row.status==0" class="text-warning">{{$t('record.status0')}}</span>
						<span v-if="scope.row.status==1" class="text-success">{{$t('record.status1')}}</span>
						<span v-if="scope.row.status==2" >{{$t('record.status2')}}</span>
					</template>
				</el-table-column>
				
                <el-table-column align="center" width="180" prop="start_time" :label="$t('record.start')">
					
				</el-table-column>
				
				<el-table-column align="center" width="180"  prop="end_time" :label="$t('record.end')">
					
				</el-table-column>
				
				
				
				<el-table-column align="center" prop="create_time" width="180" :label="$t('layout.createTime')">
				</el-table-column>
				
				
                
				
				<el-table-column align="center" width="90" fixed="right" :label="$t('layout.operation')">
					<template slot-scope="scope">
						<el-button-group>
							<el-button  size="mini" plain type="danger" v-auth="'editAdmin'" @click="deleteItem(scope.row)">{{$t('system.delete')}}</el-button>
							<!-- <el-button @click="deleteItem(scope.row)" v-auth="'delAdmin'" size="mini" plain type="danger">{{$t('layout.delete')}}</el-button> -->
						</el-button-group>
					</template>
				</el-table-column>
			</el-table>
		</div>



		<el-footer
		class="d-flex border-top bg-white align-items-center px-0 position-fixed"
		:style="{ bottom: '0', left: computedLeft, right: '0', zIndex: '100' }"
		>
			<div style="flex: 1;" class="px-2">
				<el-pagination
				:current-page="page.current"
				:page-sizes="page.sizes"
				:page-size="page.size"
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				background
				:layout="layout.is_phone ? 'total, prev, pager, next, jumper' : 'total, prev, pager, next, sizes, jumper'"
				:total="page.total"
				/>
			</div>
		</el-footer>

		<el-dialog :close-on-click-modal="false"
			:title="editIndex > -1 ? $t('record.add') : $t('record.add')"
			:visible.sync="createModel"
			top="5vh"
			:width="layout.is_phone?'90%':'80%'"
			:append-to-body="true"
			custom-class="custom-dialog">
			<!-- 表单内容 -->
			<el-form style="max-height: 65vh; overflow: auto;" :rules="rules" ref="form" :model="form" :label-width="layout.is_phone?'80px':'100px'">
				
                <el-form-item   :label="$t('live.type1')" prop="ld_id">
                	<el-select   v-model="form.ld_id" size="small" filterable :placeholder="$t('system.select')">
                	<!-- <el-option  :label="$t('live.nosel')" :value="0"> -->
                	</el-option>
                		<el-option v-for="item in tl" :key="item.id" :label="item.domain" :value="item.id">
                		</el-option>
                	</el-select>
                	
                </el-form-item>
				
				<el-form-item label="AppName" prop="app">
					<el-input v-model="form.app"  clearable size="small" placeholder="AppName"  style="width: 85%;"></el-input>
				</el-form-item>
				
				
				<el-form-item :label="$t('record.stream')" prop="stream">
					<el-input v-model="form.stream"  clearable size="small" :placeholder="$t('record.stream')"  style="width: 85%;"></el-input>
				</el-form-item>
				
                <el-form-item :label="$t('record.start')" prop="start">
					
					<el-date-picker
					      v-model="form.start"
						  clearable
					      type="datetime"
						  size="small"
						  style="width: 85%;"
					      :placeholder="$t('record.startTis')">
					    </el-date-picker>
				</el-form-item>
				
				
				<el-form-item :label="$t('record.end')" prop="end">
					<el-date-picker
					      v-model="form.end"
						  clearable
					      type="datetime"
						  size="small"
						  style="width: 85%;"
					      :placeholder="$t('record.endTis')">
					    </el-date-picker>
				</el-form-item>
				
				<el-form-item   :label="$t('record.model')" prop="tid">
					<el-select   v-model="form.tid" size="small" filterable :placeholder="$t('system.select')">
					<!-- <el-option  :label="$t('live.nosel')" :value="0"> -->
					</el-option>
						<el-option v-for="item in marr" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
					
				</el-form-item>
				
				
				
				
				
				
				
				
               
				
				
               
				
			
                
                
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">{{$t('system.cancel')}}</el-button>
				<el-button type="primary" :loading="layout.loading" :disabled="layout.loading" @click="submit">{{$t('system.confirm')}}</el-button>
			</div>
		</el-dialog>
		
		<el-dialog :close-on-click-modal="false"
				:title="$t('record.apiTis')"
				:visible.sync="apiModel"
				top="5vh"
				:width="layout.is_phone?'90%':'80%'"
				:append-to-body="true"
				custom-class="custom-dialog">
				<!-- 表单内容 -->
				
				 <template>
					 
					 <el-tabs  v-model="apiType" type="card">
					    <el-tab-pane  :label="$t('record.apiType1')" name="1"></el-tab-pane>
					    <el-tab-pane  :label="$t('record.apiType2')" name="2"></el-tab-pane>
					    <el-tab-pane  :label="$t('record.apiType3')" name="3"></el-tab-pane>
					    
					  </el-tabs>
					  
					  
					<!-- 创建录制任务 -->  
				<div class="doc-page" v-if="apiType=='1'">
					 <el-card shadow="hover">
					   <h4>{{$t('record.apitis1')}}</h4>
					   <p class="desc">{{$t('record.apitis2')}}</p>
				 
					   <el-divider>{{$t('live.apitis3')}}</el-divider>
					   <el-card shadow="never" body-style="padding: 20px; background: #fdfdfd;">
						 <div style="font-size: 14px; line-height: 2;">
					   
						   <p>
							 <strong style="width: 100px; display: inline-block;">{{$t('live.apitis4')}}：</strong>
							 <span style="color: #409EFF; font-weight: bold;">{{info.api_url}}
							 <span class="iconCopy" @click="copyText(info.api_url)"><i class="iconfont icon-fuzhi"></i></span></span>
						   </p>
					   
						   <p>
							 <strong style="width: 100px; display: inline-block;">{{$t('live.apitis5')}}：</strong>
							 <span>POST</span>
						   </p>
					   
						   <p>
							 <strong style="width: 100px; display: inline-block;">{{$t('live.apitis6')}}：</strong>
							 <span>application/json 或 x-www-form-urlencoded</span>
						   </p>
					   
						   <p>
							 <strong style="width: 100px; display: inline-block;">{{$t('live.apitis7')}}：</strong>
							 <span>MD5</span>
						   </p>
					   
						   <p>
							 <strong style="width: 100px; display: inline-block; color: #F56C6C;">{{$t('live.apitis8')}}：</strong>
							 <span style="font-family: monospace; background: #f2f2f2; padding: 2px 6px; border-radius: 4px; color: #333;">
							   {{info.api_key}}
							   <span class="iconCopy" @click="copyText(info.api_key)"><i class="iconfont icon-fuzhi"></i></span>
							   
							   <el-tooltip :content="$t('match.apiSetTis')" effect="dark" placement="top">
									
									<el-button size="mini" type="text">
										 <i class="el-icon-warning-outline ml-2" style="font-size: 16px;"></i>
									</el-button>
									
								</el-tooltip>
							   
							 </span>
						   </p>
						   
						   
						   <!-- <p>
							 <strong style="width: 100px; display: inline-block; color: #F56C6C;">client：</strong>
							 <span style="font-family: monospace; background: #f2f2f2; padding: 2px 6px; border-radius: 4px; color: #333;">
							   {{info.uid}}
							   <span class="iconCopy" @click="copyText(info.uid)"><i class="iconfont icon-fuzhi"></i></span>
												   
							 </span>
						   </p> -->
										   
					   
						 </div>
					   </el-card>
		
				 
					   <el-divider>{{$t('live.apitis9')}}</el-divider>
					   <el-table :data="apiParamList" border style="width: 100%">
						 <el-table-column prop="name" :label="$t('live.apitis16')" width="150" />
						 <el-table-column prop="type" :label="$t('live.type')" width="100" />
						 <el-table-column prop="required" :label="$t('live.apitis17')" width="80" />
						 <el-table-column prop="desc" :label="$t('live.apitis18')" />
					   </el-table>
				 
					  <el-divider>{{$t('live.apitis19')}}</el-divider>
					  <el-card shadow="never" class="mb-3">
						<div class="text-block">
						  <p>{{$t('live.apitis20')}} <code>sign</code>，{{$t('live.apitis21')}}。</p>
					  
						  
						  <p style="font-weight:bold;">{{$t('live.apitis22')}}：</p>
						  <ul>
							<li>{{$t('live.apitis23')}} <code>key</code>（{{$t('live.apitis24')}}）</li>
							<li><code>timestamp</code> {{$t('live.apitis25')}}</li>
							<li><code>nonce</code> {{$t('live.apitis26')}}</li>
							<li>{{$t('live.apitis27')}} <code>DomainName</code>、<code>startTime</code> 、<code>TemplateId</code>{{$t('live.apitis28')}}</li>
						  </ul>
					  
						  <p style="font-weight:bold;">{{$t('live.apitis29')}}：</p>
						  <ol>
							<li>{{$t('live.apitis30')}} <code>sign</code> {{$t('live.apitis31')}}</li>
							<li>{{$t('live.apitis32')}} <strong>{{$t('live.apitis33')}}</strong> {{$t('live.apitis34')}}</li>
							<li>{{$t('live.apitis35')}}：<br />
							  <code>signStr = key + timestamp + nonce + k1 + v1 + k2 + v2 + ...</code>
							</li>
							<li>{{$t('live.apitis36')}} <code>md5</code> {{$t('live.apitis37')}}</li>
							<li>{{$t('live.apitis38')}} <code>sign</code> {{$t('live.apitis39')}}</li>
						  </ol>
					  
						  <el-descriptions :title="$t('live.apitis40')" :column="1" border>
							<el-descriptions-item label="key">
							abc123456
							
							</el-descriptions-item>
							<el-descriptions-item label="DomainName">tl.example.com</el-descriptions-item>
							<el-descriptions-item label="AppName">live</el-descriptions-item>
							<el-descriptions-item label="StreamName">test001</el-descriptions-item>
							<el-descriptions-item label="startTime">2025-10-01T16:00:00Z</el-descriptions-item>
							<el-descriptions-item label="endTime">2025-10-02T16:00:00Z</el-descriptions-item>
							<el-descriptions-item label="TemplateId">1001</el-descriptions-item>
							<el-descriptions-item label="timestamp">1720000000</el-descriptions-item>
							<el-descriptions-item label="nonce">abcxyz</el-descriptions-item>
							
							
						  </el-descriptions>
					  
						  <p style="font-weight:bold; margin-top: 10px;">1. {{$t('live.apitis41')}}：</p>
						  <el-card shadow="never">
							AppName=live<br />
							DomainName=tstl.bjingqk.com<br />
							StreamName=test001<br />
							TemplateId=1001<br />
							endTime=2025-10-02T16:00:00Z<br />
							nonce=abcxyz<br />
							startTime=2025-10-01T16:00:00Z<br />
							timestamp=1720000000<br />
							
							</span>
						  </el-card>
					  
						  <p style="font-weight:bold; margin-top: 10px;">2. {{$t('live.apitis42')}}：</p>
						  <el-card shadow="never">
							abc1234561720000000abcxyzAppNameliveDomainNametstl.bjingqk.comStreamNametest001TemplateId1001endTime2025-10-02T16:00:00ZnonceabcxyzstartTime2025-10-01T16:00:00Ztimestamp1720000000
						  </el-card>
					  
						  <p style="font-weight:bold; margin-top: 10px;">3. {{$t('live.apitis44')}} md5：</p>
						  <el-card shadow="never">
							sign = md5({{$t('live.apitis44')}}) = <span style="color:#409EFF;">
								<span >14bac1551c1853b532db03e92525063f</span>
								</span>
						  </el-card>
					  
						  
						</div>
					  </el-card>
					  
					 
						<!-- 4. 请求示例 -->
						<el-divider>{{$t('live.apitis45')}}</el-divider>
						<el-card shadow="never" body-style="padding: 12px; background: #f9f9f9;">
						  <pre  style="margin: 0; font-size: 13px; line-height: 1.8; color: #333; background: none; ">
		{
			"DomainName": "tstl.bjingqk.com",
			"AppName": "live",
			"StreamName": "test001",
			"startTime": "2025-10-01T16:00:00Z",
			"endTime": "2025-10-02T16:00:00Z",
			"TemplateId": 1001,
			"timestamp": 1720000000,
			"nonce": "abcxyz",
			"sign": "14bac1551c1853b532db03e92525063f",
		}
						  </pre>
						  
						</el-card>
						
						<!-- 5. 响应示例 -->
						<el-divider>{{$t('live.apitis46')}}</el-divider>
						<el-card shadow="never" body-style="padding: 12px; background: #f9f9f9;">
						  <pre  style="margin: 0; font-size: 13px; line-height: 1.8; color: #333; background: none;">
		{
			"code": 200,
			"msg": "success",
			"TaskId": "Tau2312312213",
			"requestId": "mgw5zbdpcabb98eb2b6f3694"
		}
						  </pre>
						  
						  
						</el-card>
		
					   
					   
				 
				 
					  <el-divider >{{$t('live.apitis47')}}</el-divider>
					  <el-card   shadow="never" class="mb-3">
						<!-- <div style="font-weight: bold; margin-bottom: 10px;">{{$t('match.apitis9')}}</div> -->
						<el-table :data="[
						  { name: 'TaskId', type: 'string', desc: $t('record.apitis6') }
						  
						]" border style="width: 100%">
						  <el-table-column prop="name" :label="$t('live.apitis54')" width="160" />
						  <el-table-column prop="type" :label="$t('live.type')" width="120" />
						  <el-table-column prop="desc" :label="$t('live.apitis18')" />
						</el-table>
					  </el-card>
					  
					  
					  
					  
					  
					  
					  
					  
					  
					  
					  
					  
					  
				 
					   <el-divider >{{$t('live.apitis60')}}</el-divider>
					   <el-card shadow="never">
						 <el-table :data="[
						   { code: 200, message: 'success', desc: $t('live.apitis61') },
						   { code: 400, message: $t('live.apitis68'), desc: $t('live.apitis62') },
						   { code: 401, message: $t('live.apitis69'), desc: $t('live.apitis63') },
						   { code: 403, message: $t('match.apitis7'), desc: $t('match.apitis8') },
						   { code: 405, message: $t('live.apitis70'), desc: $t('live.apitis64') },
						   { code: 500, message: $t('live.apitis71'), desc: $t('live.apitis65') }
						 ]" border style="width: 100%">
						   <el-table-column prop="code" :label="$t('live.apitis66')" width="100" />
						   <el-table-column prop="message" :label="$t('live.apitis67')" width="220" />
						   <el-table-column prop="desc" :label="$t('live.apitis18')" />
						 </el-table>
					   </el-card>
					   
					 </el-card>
				   </div>
				   
				   <!-- 查询录制任务 -->
				   <div class="doc-page" v-if="apiType=='2'">
					 <el-card shadow="hover">
					   <h4>{{$t('record.apitis7')}}</h4>
					   <p class="desc">{{$t('record.apitis8')}}</p>
				 
					   <el-divider>{{$t('live.apitis3')}}</el-divider>
					   <el-card shadow="never" body-style="padding: 20px; background: #fdfdfd;">
						 <div style="font-size: 14px; line-height: 2;">
					   
						   <p>
							 <strong style="width: 100px; display: inline-block;">{{$t('live.apitis4')}}：</strong>
							 <span style="color: #409EFF; font-weight: bold;">{{info.api_url2}}
							 <span class="iconCopy" @click="copyText(info.api_url2)"><i class="iconfont icon-fuzhi"></i></span></span>
						   </p>
					   
						   <p>
							 <strong style="width: 100px; display: inline-block;">{{$t('live.apitis5')}}：</strong>
							 <span>POST</span>
						   </p>
					   
						   <p>
							 <strong style="width: 100px; display: inline-block;">{{$t('live.apitis6')}}：</strong>
							 <span>application/json 或 x-www-form-urlencoded</span>
						   </p>
					   
						   <p>
							 <strong style="width: 100px; display: inline-block;">{{$t('live.apitis7')}}：</strong>
							 <span>MD5</span>
						   </p>
					   
						   <p>
							 <strong style="width: 100px; display: inline-block; color: #F56C6C;">{{$t('live.apitis8')}}：</strong>
							 <span style="font-family: monospace; background: #f2f2f2; padding: 2px 6px; border-radius: 4px; color: #333;">
							   {{info.api_key}}
							   <span class="iconCopy" @click="copyText(info.api_key)"><i class="iconfont icon-fuzhi"></i></span>
							   
							   <el-tooltip :content="$t('match.apiSetTis')" effect="dark" placement="top">
									
									<el-button size="mini" type="text">
										 <i class="el-icon-warning-outline ml-2" style="font-size: 16px;"></i>
									</el-button>
									
								</el-tooltip>
							   
							 </span>
						   </p>
						   
						   
						   <p>
							 <strong style="width: 100px; display: inline-block; color: #F56C6C;">client：</strong>
							 <span style="font-family: monospace; background: #f2f2f2; padding: 2px 6px; border-radius: 4px; color: #333;">
							   {{info.uid}}
							   <span class="iconCopy" @click="copyText(info.uid)"><i class="iconfont icon-fuzhi"></i></span>
												   
							 </span>
						   </p>
										   
					   
						 </div>
					   </el-card>
		   
				 
					   <el-divider>{{$t('live.apitis9')}}</el-divider>
					   <el-table :data="apiParamList" border style="width: 100%">
						 <el-table-column prop="name" :label="$t('live.apitis16')" width="150" />
						 <el-table-column prop="type" :label="$t('live.type')" width="100" />
						 <el-table-column prop="required" :label="$t('live.apitis17')" width="80" />
						 <el-table-column prop="desc" :label="$t('live.apitis18')" />
					   </el-table>
				 
					  <el-divider>{{$t('live.apitis19')}}</el-divider>
					  <el-card shadow="never" class="mb-3">
						<div class="text-block">
						  <p>{{$t('live.apitis20')}} <code>sign</code>，{{$t('live.apitis21')}}。</p>
					  
						  
						  <p style="font-weight:bold;">{{$t('live.apitis22')}}：</p>
						  <ul>
							<li>{{$t('live.apitis23')}} <code>key</code>（{{$t('live.apitis24')}}）</li>
							<li><code>timestamp</code> {{$t('live.apitis25')}}</li>
							<li><code>nonce</code> {{$t('live.apitis26')}}</li>
							<li>{{$t('live.apitis27')}} <code>client</code>、<code>startTime</code> 、<code>PageNum</code>{{$t('live.apitis28')}}</li>
						  </ul>
					  
						  <p style="font-weight:bold;">{{$t('live.apitis29')}}：</p>
						  <ol>
							<li>{{$t('live.apitis30')}} <code>sign</code> {{$t('live.apitis31')}}</li>
							<li>{{$t('live.apitis32')}} <strong>{{$t('live.apitis33')}}</strong> {{$t('live.apitis34')}}</li>
							<li>{{$t('live.apitis35')}}：<br />
							  <code>signStr = key + timestamp + nonce + k1 + v1 + k2 + v2 + ...</code>
							</li>
							<li>{{$t('live.apitis36')}} <code>md5</code> {{$t('live.apitis37')}}</li>
							<li>{{$t('live.apitis38')}} <code>sign</code> {{$t('live.apitis39')}}</li>
						  </ol>
					  
						  <el-descriptions :title="$t('live.apitis40')" :column="1" border>
							<el-descriptions-item label="key">
							abc123456
							
							</el-descriptions-item>
							<el-descriptions-item label="client">FF10002</el-descriptions-item>
							
						
							<el-descriptions-item label="timestamp">1720000000</el-descriptions-item>
							<el-descriptions-item label="nonce">abcxyz</el-descriptions-item>
							
							
						  </el-descriptions>
					  
						  <p style="font-weight:bold; margin-top: 10px;">1. {{$t('live.apitis41')}}：</p>
						  <el-card shadow="never">
							client=FF10002<br />
							nonce=abcxyz<br />
							timestamp=1720000000<br />
							
							</span>
						  </el-card>
					  
						  <p style="font-weight:bold; margin-top: 10px;">2. {{$t('live.apitis42')}}：</p>
						  <el-card shadow="never">
							abc1234561720000000abcxyzclientFF10002nonceabcxyztimestamp1720000000
						  </el-card>
					  
						  <p style="font-weight:bold; margin-top: 10px;">3. {{$t('live.apitis44')}} md5：</p>
						  <el-card shadow="never">
							sign = md5({{$t('live.apitis44')}}) = <span style="color:#409EFF;">
								<span >906b55251323769925c17e4b147f63d7</span>
								</span>
						  </el-card>
					  
						  
						</div>
					  </el-card>
					  
					 
						<!-- 4. 请求示例 -->
						<el-divider>{{$t('live.apitis45')}}</el-divider>
						<el-card shadow="never" body-style="padding: 12px; background: #f9f9f9;">
						  <pre  style="margin: 0; font-size: 13px; line-height: 1.8; color: #333; background: none; ">
		   {
			"client": "FF10002",
			"timestamp": 1720000000,
			"nonce": "abcxyz",
			"sign": "906b55251323769925c17e4b147f63d7",
		   }
						  </pre>
						  
						</el-card>
						
						<!-- 5. 响应示例 -->
						<el-divider>{{$t('live.apitis46')}}</el-divider>
						<el-card shadow="never" body-style="padding: 12px; background: #f9f9f9;">
						  <pre  style="margin: 0; font-size: 13px; line-height: 1.8; color: #333; background: none;">
		   {
		       "code": 200,
		       "msg": "success",
		       "List": [
		           {
		               "TaskId": "Tau2312312213",
		               "DomainName": "tl.example.com",
		               "AppName": "live",
		               "StreamName": "test001",
		               "Status": "wait",
		               "StartTime": "2025-11-07T16:00:00Z",
		               "EndTime": "2025-11-08T16:00:00Z"
		           }
		       ],
		       "requestId": "mhok2it3f6271d52349bf5dc"
		   }
						  </pre>
						  
						  
						</el-card>
		   
					   
					   
				 
				 
					  <el-divider >{{$t('live.apitis47')}}</el-divider>
					  <el-card   shadow="never" class="mb-3">
						<div style="font-weight: bold; margin-bottom: 10px;">{{$t('record.apitis14')}}</div>
						<el-table :data="[
						  { name: 'TaskId', type: 'string', desc: $t('record.apitis6') },
						  { name: 'DomainName', type: 'string', desc: $t('live.type1') },
						  { name: 'AppName', type: 'string', desc: $t('live.apitis10') },
						  { name: 'StreamName', type: 'string', desc: $t('live.apitis11') },
						  { name: 'Status', type: 'string', desc: $t('record.apitis15') },
						  { name: 'StartTime', type: 'string', desc: $t('record.apitis16') },
						  { name: 'EndTime', type: 'string', desc: $t('record.apitis17') },
						  
						]" border style="width: 100%">
						  <el-table-column prop="name" :label="$t('live.apitis54')" width="160" />
						  <el-table-column prop="type" :label="$t('live.type')" width="120" />
						  <el-table-column prop="desc" :label="$t('live.apitis18')" />
						</el-table>
					  </el-card>
					  
					  
					  
					  
					  
					  
					  
					  
					  
					  
					  
					  
					  
				 
					   <el-divider >{{$t('live.apitis60')}}</el-divider>
					   <el-card shadow="never">
						 <el-table :data="[
						   { code: 200, message: 'success', desc: $t('live.apitis61') },
						   { code: 400, message: $t('live.apitis68'), desc: $t('live.apitis62') },
						   { code: 401, message: $t('live.apitis69'), desc: $t('live.apitis63') },
						   { code: 403, message: $t('match.apitis7'), desc: $t('match.apitis8') },
						   { code: 405, message: $t('live.apitis70'), desc: $t('live.apitis64') },
						   { code: 500, message: $t('live.apitis71'), desc: $t('live.apitis65') }
						 ]" border style="width: 100%">
						   <el-table-column prop="code" :label="$t('live.apitis66')" width="100" />
						   <el-table-column prop="message" :label="$t('live.apitis67')" width="220" />
						   <el-table-column prop="desc" :label="$t('live.apitis18')" />
						 </el-table>
					   </el-card>
					   
					 </el-card>
				   </div>
				   
				   <!-- 删除录制任务 -->
				   <div class="doc-page" v-if="apiType=='3'">
					 <el-card shadow="hover">
					   <h4>{{$t('record.apitis18')}}</h4>
					   <p class="desc">{{$t('record.apitis19')}}</p>
				 
					   <el-divider>{{$t('live.apitis3')}}</el-divider>
					   <el-card shadow="never" body-style="padding: 20px; background: #fdfdfd;">
						 <div style="font-size: 14px; line-height: 2;">
					   
						   <p>
							 <strong style="width: 100px; display: inline-block;">{{$t('live.apitis4')}}：</strong>
							 <span style="color: #409EFF; font-weight: bold;">{{info.api_url3}}
							 <span class="iconCopy" @click="copyText(info.api_url3)"><i class="iconfont icon-fuzhi"></i></span></span>
						   </p>
					   
						   <p>
							 <strong style="width: 100px; display: inline-block;">{{$t('live.apitis5')}}：</strong>
							 <span>POST</span>
						   </p>
					   
						   <p>
							 <strong style="width: 100px; display: inline-block;">{{$t('live.apitis6')}}：</strong>
							 <span>application/json 或 x-www-form-urlencoded</span>
						   </p>
					   
						   <p>
							 <strong style="width: 100px; display: inline-block;">{{$t('live.apitis7')}}：</strong>
							 <span>MD5</span>
						   </p>
					   
						   <p>
							 <strong style="width: 100px; display: inline-block; color: #F56C6C;">{{$t('live.apitis8')}}：</strong>
							 <span style="font-family: monospace; background: #f2f2f2; padding: 2px 6px; border-radius: 4px; color: #333;">
							   {{info.api_key}}
							   <span class="iconCopy" @click="copyText(info.api_key)"><i class="iconfont icon-fuzhi"></i></span>
							   
							   <el-tooltip :content="$t('match.apiSetTis')" effect="dark" placement="top">
									
									<el-button size="mini" type="text">
										 <i class="el-icon-warning-outline ml-2" style="font-size: 16px;"></i>
									</el-button>
									
								</el-tooltip>
							   
							 </span>
						   </p>
						   
						   
						   <!-- <p>
							 <strong style="width: 100px; display: inline-block; color: #F56C6C;">client：</strong>
							 <span style="font-family: monospace; background: #f2f2f2; padding: 2px 6px; border-radius: 4px; color: #333;">
							   {{info.uid}}
							   <span class="iconCopy" @click="copyText(info.uid)"><i class="iconfont icon-fuzhi"></i></span>
												   
							 </span>
						   </p> -->
										   
					   
						 </div>
					   </el-card>
		   
				 
					   <el-divider>{{$t('live.apitis9')}}</el-divider>
					   <el-table :data="apiParamList" border style="width: 100%">
						 <el-table-column prop="name" :label="$t('live.apitis16')" width="150" />
						 <el-table-column prop="type" :label="$t('live.type')" width="100" />
						 <el-table-column prop="required" :label="$t('live.apitis17')" width="80" />
						 <el-table-column prop="desc" :label="$t('live.apitis18')" />
					   </el-table>
				 
					  <el-divider>{{$t('live.apitis19')}}</el-divider>
					  <el-card shadow="never" class="mb-3">
						<div class="text-block">
						  <p>{{$t('live.apitis20')}} <code>sign</code>，{{$t('live.apitis21')}}。</p>
					  
						  
						  <p style="font-weight:bold;">{{$t('live.apitis22')}}：</p>
						  <ul>
							<li>{{$t('live.apitis23')}} <code>key</code>（{{$t('live.apitis24')}}）</li>
							<li><code>timestamp</code> {{$t('live.apitis25')}}</li>
							<li><code>nonce</code> {{$t('live.apitis26')}}</li>
							<li>{{$t('live.apitis27')}} <code>TaskId</code></li>
						  </ul>
					  
						  <p style="font-weight:bold;">{{$t('live.apitis29')}}：</p>
						  <ol>
							<li>{{$t('live.apitis30')}} <code>sign</code> {{$t('live.apitis31')}}</li>
							<li>{{$t('live.apitis32')}} <strong>{{$t('live.apitis33')}}</strong> {{$t('live.apitis34')}}</li>
							<li>{{$t('live.apitis35')}}：<br />
							  <code>signStr = key + timestamp + nonce + k1 + v1 + k2 + v2 + ...</code>
							</li>
							<li>{{$t('live.apitis36')}} <code>md5</code> {{$t('live.apitis37')}}</li>
							<li>{{$t('live.apitis38')}} <code>sign</code> {{$t('live.apitis39')}}</li>
						  </ol>
					  
						  <el-descriptions :title="$t('live.apitis40')" :column="1" border>
							<el-descriptions-item label="key">
							abc123456
							
							</el-descriptions-item>
							<el-descriptions-item label="TaskId">Tau2312312213</el-descriptions-item>
						
							<el-descriptions-item label="timestamp">1720000000</el-descriptions-item>
							<el-descriptions-item label="nonce">abcxyz</el-descriptions-item>
							
							
						  </el-descriptions>
					  
						  <p style="font-weight:bold; margin-top: 10px;">1. {{$t('live.apitis41')}}：</p>
						  <el-card shadow="never">
							TaskId=Tau2312312213<br />
							nonce=abcxyz<br />
							timestamp=1720000000<br />
							
							</span>
						  </el-card>
					  
						  <p style="font-weight:bold; margin-top: 10px;">2. {{$t('live.apitis42')}}：</p>
						  <el-card shadow="never">
							abc1234561720000000abcxyzTaskIdTau2312312213nonceabcxyztimestamp1720000000
						  </el-card>
					  
						  <p style="font-weight:bold; margin-top: 10px;">3. {{$t('live.apitis44')}} md5：</p>
						  <el-card shadow="never">
							sign = md5({{$t('live.apitis44')}}) = <span style="color:#409EFF;">
								<span >7864128d7c7aed284d774ac9ad16ab61</span>
								</span>
						  </el-card>
					  
						  
						</div>
					  </el-card>
					  
					 
						<!-- 4. 请求示例 -->
						<el-divider>{{$t('live.apitis45')}}</el-divider>
						<el-card shadow="never" body-style="padding: 12px; background: #f9f9f9;">
						  <pre  style="margin: 0; font-size: 13px; line-height: 1.8; color: #333; background: none; ">
		   {
			"TaskId": "Tau2312312213",
			"timestamp": 1720000000,
			"nonce": "abcxyz",
			"sign": "7864128d7c7aed284d774ac9ad16ab61",
		   }
						  </pre>
						  
						</el-card>
						
						<!-- 5. 响应示例 -->
						<el-divider>{{$t('live.apitis46')}}</el-divider>
						<el-card shadow="never" body-style="padding: 12px; background: #f9f9f9;">
						  <pre  style="margin: 0; font-size: 13px; line-height: 1.8; color: #333; background: none;">
		   {
			"code": 200,
			"msg": "success",
			"requestId": "mgw5zbdpcabb98eb2b6f3694"
		   }
						  </pre>
						  
						  
						</el-card>
		   
					   
					   
				 
				 
					  <el-divider >{{$t('live.apitis47')}}</el-divider>
					  <el-card   shadow="never" class="mb-3">
						
						<el-table :data="[
						  { name: 'msg', type: 'string', desc: $t('record.apitis21') }
						  
						]" border style="width: 100%">
						  <el-table-column prop="name" :label="$t('live.apitis54')" width="160" />
						  <el-table-column prop="type" :label="$t('live.type')" width="120" />
						  <el-table-column prop="desc" :label="$t('live.apitis18')" />
						</el-table>
					  </el-card>
					  
					  
					  
					  
					  
					  
					  
					  
					  
					  
					  
					  
					  
				 
					   <el-divider >{{$t('live.apitis60')}}</el-divider>
					   <el-card shadow="never">
						 <el-table :data="[
						   { code: 200, message: 'success', desc: $t('live.apitis61') },
						   { code: 400, message: $t('live.apitis68'), desc: $t('live.apitis62') },
						   { code: 401, message: $t('live.apitis69'), desc: $t('live.apitis63') },
						   { code: 403, message: $t('match.apitis7'), desc: $t('match.apitis8') },
						   { code: 405, message: $t('live.apitis70'), desc: $t('live.apitis64') },
						   { code: 500, message: $t('live.apitis71'), desc: $t('live.apitis65') }
						 ]" border style="width: 100%">
						   <el-table-column prop="code" :label="$t('live.apitis66')" width="100" />
						   <el-table-column prop="message" :label="$t('live.apitis67')" width="220" />
						   <el-table-column prop="desc" :label="$t('live.apitis18')" />
						 </el-table>
					   </el-card>
					   
					 </el-card>
				   </div>
			   
				 </template>
		
		
				<div slot="footer" class="dialog-footer">
					<el-button @click="apiModel = false">{{$t('safe.close')}}</el-button>
					
				</div>
			</el-dialog>

	</div>
</template>

<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	import { mapState } from 'vuex';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				apiType:'1',
				createModel: false,
				editIndex: -1,
				apiModel:false,
				rule:[],
				//搜索數据
				from: {
					name: '',
					username:'',
					app:'',
					status:-1,
					type:-1,
					rule_id:'',
					time:[],
				},
				auth_val: 'Record',
				info:{},
				preUrl: "data/liverecordList", //列表地址
				// delAllUrl: "user/delAdminAll", //批量删除地址
				delUrl: "data/delLiveRecord", //删除單条地址
				addUrl: "data/addLiveRecord", //添加/修改地址
				editStatusUrl:"user/editStatusAgent",//修改狀態地址
				type:"1",
				tableData: [],
				form: {
                    
				},
				rules: {
					app: [{
						required: true,
						message: this.$t('record.inpapp'),
						trigger: 'blur',
					}],
					stream: [{
						required: true,
						message: this.$t('record.inpstream'),
						trigger: 'blur',
					}],
					ld_id: [{
						required: true,
						message: this.$t('record.selDomain'),
						trigger: 'blur',
					}],
					tid: [{
						required: true,
						message: this.$t('record.selmodel'),
						trigger: 'blur',
					}],
					start: [
						{
							required: true,
							message: this.$t('record.selStart'),
							trigger: 'blur',
						},
						{
						  trigger: 'change',
						  validator: (rule, value, callback) => {
							if (!value) return callback();
							// 兼容 Date对象 / 字符串（配了 value-format 时是字符串）
							const ts = value instanceof Date ? value.getTime() : new Date(value).getTime();
							if (Number.isNaN(ts)) return callback(new Error(this.$t('record.invalidDatetime') || '时间格式不正确'));
							const now = Date.now();
							const upper = now + 6 * 24 * 60 * 60 * 1000; // 7天后
							if (ts <= now)   return callback(new Error(this.$t('record.mustFuture') || '必须大于当前时间'));
							if (ts >= upper) return callback(new Error(this.$t('record.mustLt7d') || '必须在未来7天内'));
							callback();
						  }
						}
					],
					end: [
						{
						required: true,
						message: this.$t('record.selEnd'),
						trigger: 'blur',
						},
						{
						  trigger: 'change',
						  validator: (rule, value, callback) => {
							if (!value) return callback();             // required 兜底
							const startVal = this.form.start;
							if (!startVal) return callback(new Error(this.$t('record.pickStartFirst') || '请先选择开始时间'));
					
							// 兼容 Date 或 字符串（有 value-format 时是字符串）
							const toTs = v => v instanceof Date ? v.getTime() : new Date(v).getTime();
							const endTs   = toTs(value);
							const startTs = toTs(startVal);
					
							if ([endTs, startTs].some(Number.isNaN)) {
							  return callback(new Error(this.$t('record.invalidDatetime') || '时间格式不正确'));
							}
							if (endTs < startTs) {
							  return callback(new Error(this.$t('record.endGteStart') || '结束时间不能小于开始时间'));
							}
					
							const diff = endTs - startTs;                    // 毫秒
							const MIN5  = 5 * 60 * 1000;
							const MAX24 = 24 * 60 * 60 * 1000;
					
							if (diff < MIN5) {
							  return callback(new Error(this.$t('record.min5min') || '间隔不能小于5分钟'));
							}
							if (diff > MAX24) {
							  return callback(new Error(this.$t('record.max24h') || '间隔不能超过24小时'));
							}
							callback();
						  }
						}
					],
					
					
				},
				tl:[],
				marr:[],
				agent_list: [],
				check_img_list:[]
			}
		},
		watch: {
			refreshTrigger(newVal) {
				this.getList();    // 如果有其他需要刷新的方法
				this.layout.getPageNum();
			},
		},
		computed: {
			// 监听 Vuex state
			...mapState(['refreshTrigger']), // 监听 Vuex state
			apiParamList() {
			    const list = [
					{ name: 'DomainName', type: 'string', required: this.$t('live.yes'), desc: this.$t('live.type1')},
					{ name: 'AppName', type: 'string', required: this.$t('live.yes'), desc: this.$t('live.apitis10') },
					{ name: 'StreamName', type: 'string', required: this.$t('live.yes'), desc: this.$t('live.apitis11') },
			      { name: 'client', type: 'string', required: this.$t('live.yes'), desc: this.$t('match.client'),check:true},
			      { name: 'startTime', type: 'string', required: this.$t('live.yes'), desc: this.$t('record.apitis3') },
			      { name: 'endTime', type: 'string', required: this.$t('live.yes'), desc: this.$t('record.apitis4') },
				  { name: 'TemplateId', type: 'int', required: this.$t('live.yes'), desc: this.$t('record.apitis5') },
				  
				  
				  { name: 'PageNum', type: 'int', required: this.$t('live.no'), desc: this.$t('record.apitis9') ,check:true},
				  { name: 'PageSize', type: 'int', required: this.$t('live.no'), desc: this.$t('record.apitis10') ,check:true},
				  { name: 'startTime', type: 'string', required: this.$t('live.no'), desc: this.$t('record.apitis11') ,check:true},
				  { name: 'endTime', type: 'string', required: this.$t('live.no'), desc: this.$t('record.apitis12') ,check:true},
				  { name: 'TaskId', type: 'string', required: this.$t('live.no'), desc: this.$t('record.apitis13') ,check:true},
				  
				  { name: 'TaskId', type: 'string', required: this.$t('live.no'), desc: this.$t('record.apitis20') ,del:true},
			      
			      { name: 'timestamp', type: 'int', required: this.$t('live.yes'), desc: this.$t('live.apitis13') ,com:true},
			      { name: 'nonce', type: 'string', required: this.$t('live.yes'), desc: this.$t('live.apitis14') ,com:true},
			      { name: 'sign', type: 'string', required: this.$t('live.yes'), desc: this.$t('live.apitis15') ,com:true}
				  
				 
			    ];
			
			    return list.filter(item => {
			        if (this.apiType == '1') {
			          // 查询
			          return !item.check;
			        } 
					if (this.apiType == '2') {
					  // 查询
					  return item.check || item.com;
					} 
					if (this.apiType == '3') {
					  // 查询
					  return item.del || item.com;
					} 
			      });
			  }
		},
		created() {
			this.commonList(['recordData']);
		},
		methods: {
			limitRebate(val) {
			    const n = Number(val)
			    if (!Number.isFinite(n)) { this.form.rebate = null; return }
			    const clamped = Math.min(100, Math.max(0, n))
			    this.form.rebate = Math.trunc(clamped)   // 只要整数
			  },
            validateParent(rule, value, callback) {
                if (this.form.id > 0) {
                    if (!value) {
                        return callback(new Error(this.$t('agentList.passwordLength'))); // 只有 type == 2 时才校验
                    }
                }
                callback(); // 其他情况不校验
            },
			//提交
			submit() {
				if (this.form.password != this.form.password2) {
					this.$message({
						message: this.$t('agentList.differentPasswords'),
						type: 'error'
					});
					return
				}
				this.$refs.form.validate(res => {
					// if(!this.form.headUrl){
					// 	this.$message.error(this.$t('agentList.upProfile'));
					// 	return false
					// }
					if (res) {
						//this.form.default = this.form.default.replace(/\n/g,',')
						this.form.id = this.editIndex
						this.addOrEdit(this.form)
						// 關閉模态框
					}
				})
			},

			// 打开模态框
			openModel(e = false) {
				// 增加
				if (!e) {
					// 初始化表單
					this.form = {
						ld_id: "",
						stream:'',
						app:'live',
						start:'',
						end:'',
						tid:''
					}
					this.editIndex = -1
				} else {
					// 修改
					this.form = {
						name: e.row.name,
						min: e.row.min,
						max:  e.row.max,
						type:  e.row.type,
						rebate:  e.row.rebate,
						level:  e.row.level,
						
					}
					this.editIndex = e.row.id
				}
				// 打开dialog
				this.createModel = true
			},
			//公共列表
			commonList(type) {
				this.layout.loading = true;
				this.axios.post('/admin/user/commonList', {
					type: type,
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					this.tl = list.tl
					this.marr = list.marr
					this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},
			handleAvatarSuccess(res, file) {
				this.form.icon = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.headUrl = res.encryption.data.list.url
				}
			  },
            handleAvatarSuccessTg(res, file) {
				this.form.tg_qr = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.tgQrUrl = res.encryption.data.list.url
				}
			},
			beforeAvatarUpload(file) {
							const isJPG = file.type === 'image/jpeg';
							const isLt2M = file.size / 1024 / 1024 < 2;
					
							return isJPG && isLt2M;
			},
			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			getListResult(e) {
				this.tableData = e.list
				this.info = e.info
				this.check_img_list = e.list.map(item=>{
					return item.head
				})
			},
			// 清空篩選條件
			clearSearch() {
				this.from = {
					name: '',
					username:'',
					app:'',
					status:-1,
					type:-1,
					rule_id:'',
					time:[],
				}
			
				//this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.getList()
			},
			// 選擇图片
			chooseImage() {
				this.app.chooseImage((res) => {
					//console.log(res)
					//this.form.headUrl = ''
					this.$set(this.form, 'headUrl', res[0].url);
					this.form['headId'] = res[0].id
					this.$set(this.form, 'headId', res[0].id);
					//this.form.headUrl = res[0].url
				}, 1)
			}
		}
	}
</script>

<style>
.custom-dialog {
  z-index: 3000!important; /* 设置更高的 z-index */
}
</style>
